<mat-dialog-content>
  <h2 mat-dialog-title>Confirm Quote Creation</h2>
  <div style="text-align:center;">
    <p>Create a new quote for <b>{{data.hs_full_name}}</b>?</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()">Yes</button>
</mat-dialog-actions>
